module.exports = __webpack_public_path__ + "img/8_3.fb3840ba.png";